export const getSessionStorage = (key) => {
    let sessionData = sessionStorage.getItem(key)
    
    return sessionData ? JSON.parse(sessionData) : []
}